module.exports = __webpack_public_path__ + "assets/img/title-8c27bd29.png";